// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"470px","contactContainer":"contact_contactContainer__22gng","contactBlockContainer":"contact_contactBlockContainer__k8m9o","contactBlock":"contact_contactBlock__nLdJ1"};